module.exports = __webpack_public_path__ + "img/table.1a58fcec.jpg";